export default "__VITE_ASSET__DEliXLmZ__"